module.exports = __webpack_public_path__ + "img/cancel.7c29d03c.svg";